module.exports = __webpack_public_path__ + "static/img/bg-ar.1f718d5f.png";